import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-290" data-mp="2wzp0ipo56tcp">
      <div className="mx-auto max-w-3xl" data-id="element-291" data-mp="2t0g8bp8r33j9">
        <SectionHeading eyebrow="The content" title="What is inside Kidney Disease Route™?" subtitle="A complete clinical decision system that takes you from the first abnormal creatinine to long-term kidney disease follow-up." data-id="element-292" data-mp="2szey1mzk6l2l" />

        <div className="mt-9 space-y-4 sm:mt-12 sm:space-y-6" data-id="element-293" data-mp="2ebtsznj4ibs1">
          {volumes.map(volume => <article key={volume.title} className="rounded-3xl border border-navy-100 bg-white p-5 sm:p-8" data-id="element-294" data-mp="29d0epsw0igqt">
              <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.16em] text-brick-600 sm:text-xs" data-id="element-295" data-mp="20b0wwyd6b8mt">
                <span className="text-base" aria-hidden="true" data-id="element-296" data-mp="335e4bpukjsel">
                  {volume.emoji}
                </span>
                {volume.number}
              </p>
              <h3 className="mt-2 font-display text-[24px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-297" data-mp="2u4xwy5apg14g">
                {volume.title}
              </h3>
              <p className="mt-2.5 text-[15px] font-semibold leading-snug text-navy-700 sm:text-lg" data-id="element-298" data-mp="2y6szte8aamkc">
                {volume.promise}
              </p>
              <p className="mt-3 text-[14px] font-medium leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-299" data-mp="3qvqihigeqldm">
                {volume.intro}
              </p>

              <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-x-5" data-id="element-300" data-mp="3cv5vea3gm3eb">
                {volume.items.map(item => <li key={item} className="flex gap-2" data-id="element-301" data-mp="21gjyxpjm94sw">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick-600" aria-hidden="true" data-id="element-302" data-mp="21ez7i8slm1z9" />
                    <span className="text-[13.5px] font-medium leading-snug text-navy-700 sm:text-[14.5px]" data-id="element-303" data-mp="by3le90gve5f">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <p className="mt-5 flex gap-2.5 rounded-2xl bg-navy-50 px-4 py-3.5" data-id="element-304" data-mp="27simpsirb04">
                <TargetIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-700" aria-hidden="true" data-id="element-305" data-mp="3uccukv9h46y3" />
                <span className="text-[13.5px] font-semibold leading-relaxed text-navy-800 sm:text-[14.5px]" data-id="element-306" data-mp="3peukh1jpzloi">
                  {volume.goal}
                </span>
              </p>
            </article>)}
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-307" data-mp="3fhy98o2fslg9">
          <CTAButton label="I want all 6 clinical volumes" subline="6 premium volumes + 5 bonuses • Instant digital access" data-id="element-308" data-mp="3bes45jr290bd" />
        </div>
      </div>
    </section>;
}